module.exports = __webpack_public_path__ + "static/HelloFresh-logo-a2a149bdc1548e071bb89411547914ca.png";